import { Component, Input } from '@angular/core';

@Component({
    selector: 'skeleton',
    templateUrl: './skeleton.component.html',
    styleUrls: ['./skeleton.component.scss'],
})
export class SkeletonComponent {
    @Input() public animated: boolean = false;
}
